import request from '@/utils/request'

// 新建来源小程序
export function videoSettingstore(data) {
  return request({
    url: '/appletLifeVideo/videoSetting/store',
    method: 'post',
    data
  })
}

// 更新来源小程序
export function videoSettingupdate(data) {
  return request({
    url: '/appletLifeVideo/videoSetting/update',
    method: 'post',
    data
  })
}
// 来源小程序列表
export function videoSettinglist(params = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/list',
    method: 'get',
    params
  })
}
// 删除来源小程序
export function videoSettingdelete(data) {
  return request({
    url: '/appletLifeVideo/videoSetting/delete',
    method: 'post',
    data
  })
}

// 目标分类列表
export function videoCategorylist(params = {}) {
  return request({
    url: '/appletLifeVideo/videoCategory/list',
    method: 'get',
    params
  })
}
// 新建目标分类
export function videoCategorystore(data) {
  return request({
    url: '/appletLifeVideo/videoCategory/store',
    method: 'post',
    data
  })
}

// 更新目标分类
export function videoCategoryupdate(data) {
  return request({
    url: '/appletLifeVideo/videoCategory/update',
    method: 'post',
    data
  })
}
// 删除小目标分类
export function videoCategorydelete(data) {
  return request({
    url: '/appletLifeVideo/videoCategory/delete',
    method: 'post',
    data
  })
}
// 分类关联列表
export function videoCategoryRelationlist(params = {}) {
  return request({
    url: '/appletLifeVideo/videoCategoryRelation/list',
    method: 'get',
    params
  })
}
// 删除分类关联
export function videoCategoryRelationdelete(data) {
  return request({
    url: '/appletLifeVideo/videoCategoryRelation/delete',
    method: 'post',
    data
  })
}
// 来源小程序分类
export function videoSettingcategoryList(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/categoryList',
    method: 'post',
    data
  })
}
// 生活祝福小程序列表
export function videoSettingappletLifeList(params = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/appletLifeList',
    method: 'get',
    params
  })
}
// 新建分类关联
export function videoCategoryRelationstore(data = {}) {
  return request({
    url: '/appletLifeVideo/videoCategoryRelation/store',
    method: 'post',
    data
  })
}
// 分类关联详情
export function videoCategoryRelationdetail(params = {}) {
  return request({
    url: '/appletLifeVideo/videoCategoryRelation/detail',
    method: 'get',
    params
  })
}
// 编辑分类关联
export function videoCategoryRelationupdate(data = {}) {
  return request({
    url: '/appletLifeVideo/videoCategoryRelation/update',
    method: 'post',
    data
  })
}
// 视频列表
export function videoSettingvideoList(params = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/videoList',
    method: 'get',
    params
  })
}
// 激励|视频广告开启
export function videoSettingopenAd(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/openAd',
    method: 'post',
    data
  })
}
// 删除视频
export function videoSettingdelVideo(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/delVideo',
    method: 'post',
    data
  })
}
// 获取腾讯云配置
export function getQcConfig(params) {
  return request({
    url: '/sourceMaterial/qcConfig',
    method: 'get',
    params
  })
}
// 新建小游戏配置
export function gameSettingstore(data = {}) {
  return request({
    url: '/wxCps/gameSetting/store',
    method: 'post',
    data
  })
}
// 小游戏配置列表
export function gameSettinglist(params) {
  return request({
    url: '/wxCps/gameSetting/list',
    method: 'get',
    params
  })
}
// 删除小游戏配置
export function gameSettingdelete(data = {}) {
  return request({
    url: '/wxCps/gameSetting/delete',
    method: 'post',
    data
  })
}
// 更新小游戏配置
export function gameSettingupdate(data = {}) {
  return request({
    url: '/wxCps/gameSetting/update',
    method: 'post',
    data
  })
}
// cps列表
export function settinglist(params) {
  return request({
    url: '/wxCps/setting/list',
    method: 'get',
    params
  })
}
// 删除cps
export function settingdelete(data = {}) {
  return request({
    url: '/wxCps/setting/delete',
    method: 'post',
    data
  })
}
// 新建cps
export function settingstore(data = {}) {
  return request({
    url: '/wxCps/setting/store',
    method: 'post',
    data
  })
}
// 更新cps
export function settingupdate(data = {}) {
  return request({
    url: '/wxCps/setting/update',
    method: 'post',
    data
  })
}
// 新建cps推广链接
export function officialAccountgenerate(data = {}) {
  return request({
    url: '/officialAccount/generate',
    method: 'post',
    data
  })
}
// cps推广链接列表
export function wxCpspromotionlist(params) {
  return request({
    url: '/wxCps/promotion/list',
    method: 'get',
    params
  })
}
// 删除cps推广链接
export function wxCpspromotiondelete(data = {}) {
  return request({
    url: '/wxCps/promotion/delete',
    method: 'post',
    data
  })
}
// 更新cps推广链接
export function wxCpspromotionupdate(data = {}) {
  return request({
    url: '/wxCps/promotion/update',
    method: 'post',
    data
  })
}
// 小程序开启跳转小游戏
export function officialAccountopenJumpGame(data = {}) {
  return request({
    url: '/officialAccount/openJumpGame',
    method: 'post',
    data
  })
}
// 是否开启跳转小程序
export function appletLifeVideovideoSettingpopGame(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/popGame',
    method: 'post',
    data
  })
}
// 九宫格扣减书币列表
export function activityurntablegiveDeductRecordList(params) {
  return request({
    url: '/activity/Turntable/giveDeductRecordList',
    method: 'get',
    params
  })
}
// 获取所有的类目
export function appletLifeVideovideoSettingallCategory(params) {
  return request({
    url: '/appletLifeVideo/videoSetting/allCategory',
    method: 'get',
    params
  })
}
// 推广单游戏列表地址
export function gameListlist(params) {
  return request({
    url: '/wxCps/gameList/list',
    method: 'get',
    params
  })
}
// 删除推广单游戏列表地址
export function gameListdelete(data = {}) {
  return request({
    url: '/wxCps/gameList/delete',
    method: 'post',
    data
  })
}
// 小程序列表包括已绑定
export function gameListgetAppletAndBind(params) {
  return request({
    url: '/wxCps/gameList/getAppletAndBind',
    method: 'get',
    params
  })
}
// 游戏链接新建
export function gameListstore(data = {}) {
  return request({
    url: '/wxCps/gameList/store',
    method: 'post',
    data
  })
}
// 游戏链接绑定小程序记录
export function gameListbindList(params) {
  return request({
    url: '/wxCps/gameList/bindList',
    method: 'get',
    params
  })
}
// 游戏链接解绑小程序
export function gameListunbind(data = {}) {
  return request({
    url: '/wxCps/gameList/unbind',
    method: 'post',
    data
  })
}
// 游戏链接解绑小程序
export function gameListupdate(data = {}) {
  return request({
    url: '/wxCps/gameList/update',
    method: 'post',
    data
  })
}
// 新增素材批量(腾讯云)
export function storeBatchQc(data = {}) {
  return request({
    url: '/sourceMaterial/storeBatchQc',
    method: 'post',
    data
  })
}
// 编辑祝福视频标题
export function videoSettingupdateVideo(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/updateVideo',
    method: 'post',
    data
  })
}
// 手动创建视频
export function videoSettinghandStore(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/handStore',
    method: 'post',
    data
  })
}
// 绑定分类
export function bangfnellie(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/bindCategory',
    method: 'post',
    data
  })
}
// 统计视频数据
export function videoSettingstatistics(params) {
  return request({
    url: '/appletLifeVideo/videoSetting/statistics',
    method: 'get',
    params
  })
}
